const PAGES = { FOOTER: 'footer', SWEEPR: 'SWEEPR', HEADER: 'header' };
const SERVICES = {
  DUALPLAY: 'DUALPLAY',
  DUALPLAY_PSTN: 'DUALPLAY_PSTN',
  SA_PSTN: 'SA_PSTN',
  DUALPLAY_NBI: 'DUALPLAY_NBI',
  TV: 'TV',
  MOBILE: 'MOBILE',
};
const ERROR_MESSAGES = {
  STANDARD: 'Something went wrong, please check server logs',
};

const STRAPI_ACTION_MODALS = 'eir-action-modals';
const REGEX = {
  EMAIL:
    /* eslint-disable no-useless-escape */
    // Disable this rule for defining regex as per requirement
    /^([a-zA-Z0-9_\-\.+]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$/,
  PASSWORD: /^.{6,}$/,
  ACCOUNT_NUMBER: /^[0-9a-zA-Z]{6,24}$/,
  LANDLINE_NUMBER: /^\d{4}$/,
};
const MODALS = {
  LOGIN_VERIFICATION: 'sweepr-verify-login-details',
  ACCOUNT_VERIFICATION: 'sweepr-verify-account-details',
  BROADBAND_SUPPORT: 'sweepr-broadband-support-redirect',
  MOBILE_SUPPORT: 'sweepr-mobile-support-redirect',
  EIR_SUPPORT: 'sweepr-eir-support-redirect',
};

const ACTIONS = {
  SWEEPR_TROUBLESHOOT: 'SWEEPR_TROUBLESHOOT',
  SWEEPR_VERIFY_LOGIN: 'SWEEPR_VERIFY_LOGIN',
  SWEEPR_VERIFY_ACCOUNT: 'SWEEPR_VERIFY_ACCOUNT',
  SWEEPR_VERIFY_SWITCH_TO_LOGIN: 'SWEEPR_VERIFY_SWITCH_TO_LOGIN',
  SWEEPR_VERIFY_SWITCH_TO_ACCOUNT: 'SWEEPR_VERIFY_SWITCH_TO_ACCOUNT',
  SWEEPR_LOGIN_TO_EIR_APP: 'SWEEPR_LOGIN_TO_EIR_APP',
  GENERIC_REDIRECT: 'GENERIC_REDIRECT',
  GENERIC_CALL_DIALER: 'GENERIC_CALL_DIALER',
  GENERIC_WEB_CHAT: 'GENERIC_WEB_CHAT',
  GENERIC_CLOSE: 'GENERIC_CLOSE',
  ERROR_TRY_AGAIN: 'ERROR_TRY_AGAIN',
  ERROR_CLOSE: 'ERROR_CLOSE',
};

const SWEEPR_WIDGET_ERROR = {
  TITLE: 'Something went wrong.',
  DESCRIPTION: "We couldn't load our support tool, please try again.",
  TRY_AGAIN: 'Try again', // CTA name for first try
  CLOSE: 'Close', // CTA name for second retry
  TYPE: 'solid', // Button type
};

const RECAPTCHA = {
  V2: 'V2',
  V3: 'V3',
  RECAPTCHA_KEY_V2: '6LfZsRYTAAAAAJMBqawqK3sy7NmHDC8M9rKdkX36',
  RECAPTCHA_KEY_V3: '6Le2qgUqAAAAABvwuaR9zreIQJqB9R6_TIozGGHQ',
};
const SYSTEM = {
  EIR: 'eirie',
};

export {
  PAGES,
  SERVICES,
  ERROR_MESSAGES,
  MODALS,
  STRAPI_ACTION_MODALS,
  REGEX,
  ACTIONS,
  RECAPTCHA,
  SYSTEM,
  SWEEPR_WIDGET_ERROR,
};
